/*
    Journey UI Container -- since we cant use React Router, we have
    to manage the UI state ourselves. This container determines
    which children UI elements to draw, depending on global state
    */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import JourneyHome from './JourneyHome/JourneyHome'
import CreditNavBar from './JourneyHome/CreditNavBar'
import JourneySelector from './JourneyHome/JourneySelector'
import JourneyStep from './JourneyStep/JourneyStep'
import JourneyStepProgress from './JourneyStep/JourneyStepProgress'
import JourneyNavProgress from './JourneyNavProgress/JourneyNavProgress'
import EnterYourName from './FinalizeJourney/EnterYourName'
import JourneyPrint from './FinalizeJourney/JourneyPrint'
import JourneyDone from './FinalizeJourney/JourneyDone'
import Modal from './Modal'
import { fetchJourneysIfNeeded } from '../actions/journey-actions'
import { currentNavStep, showIdleWarning, kioskMode } from '../selectors/journeyState-selectors'
import Transition from 'react-motion-ui-pack'
import { spring, presets } from 'react-motion'
import { resetInactivityTimer } from '../actions/util-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../utils/hammerOptions';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import '../css/JourneyMasterUI.css'

import continueButton from '../assets/btn_continue.png'
import homeAnimation from '../assets/bg-home-animated.mp4'

class JourneyMasterUI extends React.Component {
   constructor(props) {
      super(props)

      // keeping track of dom references to calculate dynamic transition height
      this.elementHeights = {
         'journey-step-progress': null,
         'credit-nav-bar': null
      }
   }

   componentDidMount() {
      const { fetchJourneysIfNeeded } = this.props
      fetchJourneysIfNeeded()
   }

   /* some bindings to handle dynamic height of elements for use with translateY */
   updateHeight = (key, element) => (element ? this.elementHeights[key] = element.clientHeight : null)
   enterY = () => ({opacity: 1, translateY: spring(0, presets.gentle)})
   leaveBottom = (key) => ({opacity: 0, translateY: (this.elementHeights[key] ? (this.elementHeights[key]) : 100)})
   leaveTop = (key) => ({opacity: 0, translateY: -(this.elementHeights[key] ? (this.elementHeights[key]) : 100)})

   render() {
   const { galleryId, rotate, currentNavStep, 
      appHeight, appWidth, showIdleWarning, resetInactivityTimer,
      kioskMode } = this.props

   let extraContainerClass = 'bg-default'
   if (currentNavStep === 0) {
      extraContainerClass = ((kioskMode && true) ? '' : 'bg-home')
   } else if (currentNavStep === 5) {
      extraContainerClass = 'bg-end'
   }
   // handle flipping and transform
   return (
      <Transition
      component={false}
      enter={{opacity: spring(1, {stiffness: 50, damping: 15})}}
      leave={{opacity: 0}}>
         <div key='journey-container' 
            className={`journey-container ${extraContainerClass} journey-container-${galleryId}`} 
            style={{transform: rotate, height: appHeight + 'px', width: appWidth + 'px'}}>
            
            {/* Top Nav Bar: Always displayed */}
            <ReactCSSTransitionGroup
               transitionName="ui-transition0"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
            { currentNavStep > 0 &&
               <div className={'nav-progress-bar'}  key='nav-progress-bar' ref={(element) => this.updateHeight('nav-progress-bar', element)}>
                  <JourneyNavProgress galleryId={galleryId} />
               </div>
            }
            </ReactCSSTransitionGroup>

            {/* Journey Home: Only shown on step 0 */}
            <ReactCSSTransitionGroup
               transitionName="ui-transition1"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>            
               {currentNavStep === 0 && 
               <span>
                     { kioskMode && true && 
                        <video width="100%" height="100%" loop autoPlay>
                          <source src={homeAnimation} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                     }
                  <div className={'journey-content-container max-height'} key={'journey-content-container'}>
                     <JourneyHome galleryId={galleryId} />
                  </div>
               </span>
            }
            </ReactCSSTransitionGroup>

            {/* Journey Selector, Step 1 only */}
            <ReactCSSTransitionGroup
               transitionName="ui-transition1"
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>               
               {currentNavStep === 1 && 
                  <div className={'journey-content-container'} key={'journey-content-container'}>
                     <JourneySelector galleryId={galleryId}/>
                  </div>
               }
            </ReactCSSTransitionGroup>

            {/* Artwork Selection, Step 2 only */}
               {currentNavStep === 2 &&
                  <div className={'journey-content-container'} key={'journey-content-container'}>
                     <JourneyStep galleryId={galleryId} />
                  </div>
               }

            {/* Credit Nav Bar: Steps 0, only */}
            {currentNavStep < 1 &&
               <div className={'top-nav-container'} key='bottom-nav-container' ref={(element) => this.updateHeight('credit-nav-bar', element)}>
                  <CreditNavBar />
               </div>
            }

            {/* Journey Progress, Step 2 only */}
            <Transition component={false} enter={this.enterY()} leave={this.leaveBottom('journey-step-progress')}>
            {currentNavStep === 2 &&
               <div 
                  className={'bottom-nav-container'} 
                  key='bottom-nav-container'
                  ref={(element) => this.updateHeight('journey-step-progress', element)}>
                  <JourneyStepProgress galleryId={galleryId} />
               </div>
            }
            </Transition>

            {/* Personalize Your Journey, step 3 only */}         
            <ReactCSSTransitionGroup
               transitionName="ui-transition2"
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
               {currentNavStep === 3 &&
                  <div className={'journey-content-container'} key={'journey-content-container'}>
                     <EnterYourName galleryId={galleryId} />
                  </div>
               }
            </ReactCSSTransitionGroup>

            <ReactCSSTransitionGroup
               transitionName="ui-transition3"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
               {currentNavStep === 4 &&
                  <div className={'journey-content-container'} key={'journey-content-container'}>
                     <JourneyPrint galleryId={galleryId} />
                  </div>
               }
            </ReactCSSTransitionGroup>

            <ReactCSSTransitionGroup
               transitionName="ui-transition3"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
               {currentNavStep === 5 &&
                  <div className={'journey-content-container'} key={'journey-content-container'}>
                     <JourneyDone galleryId={galleryId} />
                  </div>
               }
            </ReactCSSTransitionGroup>

            <ReactCSSTransitionGroup
               transitionName="ui-transition0"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
               {showIdleWarning && 
                  <Modal onRequestClose={() => {}} key='idle-modal' className={'idle-modal'}>
                  <div className='large-1'>
                     <h1 className='large-4'>Are you still there?</h1>
                     <p className='large-3'>Please continue to complete your art hunt.</p>
                     <Hammer onTap={() => resetInactivityTimer(galleryId)} options={tapOptions} >
                        <img src={continueButton} alt={'continue button'} />
                     </Hammer>
                  </div>
                  </Modal>
               }
            </ReactCSSTransitionGroup>

         </div>
      </Transition>
      )
   }
}

const mapStateToProps = (state, ownProps) => ({
 currentNavStep: currentNavStep(state, ownProps),
 kioskMode: kioskMode(state, ownProps),
 appHeight: state.util.get('appHeight'),
 appWidth: state.util.get('appWidth'),
 rotate: 'rotate(0deg)',
 showIdleWarning: showIdleWarning(state, ownProps),
 ...ownProps,
})
const mapDispatchToProps = dispatch => bindActionCreators({
 fetchJourneysIfNeeded,
 resetInactivityTimer,
}, dispatch)

export default connect(
 mapStateToProps,
 mapDispatchToProps
 )(JourneyMasterUI)


// WEBPACK FOOTER //
// ./src/components/JourneyMasterUI.js